export default __webpack_public_path__ + "static/adorno5-cddc5ce0c21ce51cdab6214ae971c8f0.png";